export const parseFromString = (text) => {
  // This is done to make sure the link, script and other tags which normally reside in head are avaibale to us in body
  return new DOMParser().parseFromString(`<body>${text}</body>`, 'text/html').body
}